export default "__VITE_ASSET__B1ggSwhK__"